// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EUc5d","index":"styles_index__3PXLH"};